import { render, staticRenderFns } from "./Informatique.vue?vue&type=template&id=de90ae30&"
import script from "./Informatique.vue?vue&type=script&lang=js&"
export * from "./Informatique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports